import React, { Component } from "react";
import { PnkConnect } from '../../../pnk-react/pnk-miniredux';

// import $ from 'jquery';
import AppUtils from '../../../apputils';
import TourListPage from "./tour-list";
import { GetToursList, GetTourDetails, DeleteTour } from "../../../models/tour";
import { CreateTour } from "../CreateTour";
import DeleteModal from "./deleteModal";
import { SitemapEventsList } from "../../../models/events";


class tourList extends Component {
    constructor() {
        super()
        this.state = {
            TourDetails: false,
            TourDetailsData: {},
            getTours: true,
            isModalOpen: false,
            delete_tour:false,
            getTourSitemapList:false,
            getEventSitemapList:false,
            deleteTourid: '',
            tour_id: '',
            tourlist: []
        }
    }

    HandleRouting = (route) => {
        AppUtils.HandlePageClick(this.props.componentprops, route)
    }

    GetTourDetails = (id) => {

        this.setState({
            tour_id: id,
            TourDetails: true,
        })


    }
    CloseDeleteModal = ()=>{
        this.setState({
            isModalOpen:false
        })
    }

    DeleteTour = ()=>{
     //   alert('deleted')
        this.setState({
            delete_tour:true
        })
    }
    DeleteModal = (id) => {

        this.setState({
            isModalOpen: true,
            deleteTourid:id
        })


    }
    AddTour = () => {
        this.ShowAddTourModal();
    }
    ShowAddTourModal = () => {
        this.props.componentprops.OpenModal(CreateTour, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', close: this.CloseModal, title: 'Add Tour', action: 'Create' }, { action: 'Create', name: 'Create', Close: this.CloseModal })
    }

    ShowUpdateTourModal = () => {
        this.props.componentprops.OpenModal(CreateTour, 'md', { modalClass: 'profile-entry-modal', headerClass: 'profile-entry-header', titleClass: 'profile-entry-title', title: 'Add Lead Source', action: 'Detail', data: this.state.TourDetailsData, close: this.CloseModalTwo }, { action: 'Detail', name: 'Detail', close: this.CloseModalTwo })
    }

    CloseModalTwo = ()=>{
        this.setState({
            getTours: true,
           
        })
        this.props.componentprops.HandleCloseModal();
    }
    CloseModal = () => {
        //   alert('jjj')

        if(localStorage.getItem('session_list') !== null && localStorage.getItem('session_list') !== undefined && localStorage.getItem('session_list') !== ''){
            this.setState({
                getTours: true,
                getTourSitemapList:true
            })
        }
        else{
        this.setState({
            getTours: true,
            getTourSitemapList:true,
            getEventSitemapList:true
        })
    }
        this.props.componentprops.HandleCloseModal();

    }

    HandleGetToursSitemapListSuccessResponse = (res)=>{

        let tours_list = []
        if (res !== false) {
            res.data.tourslist.rows.map((item) => {
                tours_list.push({ "id": item.tour_seo_url})
            })
 
            localStorage.setItem("tour_list", JSON.stringify(tours_list));
 
            window.open('https://www.kinshipliving.com/sitemap')
           // window.focus()
 
 
 
        }
      
        this.setState({
            getTourSitemapList: false
        })
 

    }

    HandleGetSitemapEventsListSuccessResponse = (res) => {
        //    alert('IN SITEMAP');
           let sessions_list = []
           if (res !== false) {
               res.data.eventslist.rows.map((item) => {
                   sessions_list.push({ "id": item.seo_url})
               })
    
               localStorage.setItem("session_list", JSON.stringify(sessions_list));
    
           }
         
           this.setState({
            getEventSitemapList: false
           })
       }
    

    HandleGetToursListSuccessResponse = (res) => {
        if (res !== false) {
            console.log(JSON.stringify(res.data))
            this.setState({
                tourlist: res.data.tourslist.rows,
                getTours: false

            })
        }

        else {
            this.setState({

                getTours: false
            })
        }
    }

    HandleGetTourDetailsSuccessResponse = (res) => {
        if (res !== false) {
            console.log(res.data.tourdetails.rows);
            this.setState({
                TourDetailsData: res.data.tourdetails.rows,
                TourDetails: false
            })
            this.ShowUpdateTourModal();

        }
        else {
            this.setState({
                TourDetails: false
            })
        }
    }

    HandleDeleteTourDetailsSuccessResponse = (res)=>{
        if(res !== false){
            this.setState({
                delete_tour:false,
                isModalOpen:false,
                getTours:true
            })
        }

        else{
            this.setState({
                delete_tour:false,
                getTours:true
            })
        }
    }

    render() {
        return (
            <div>
                {localStorage.getItem('current_user_profile') !== null && localStorage.getItem('current_user_profile') === 'admin' ?
                    <TourListPage {...this.props} HandleRouting={this.HandleRouting}
                        tourlist={this.state.tourlist} ShowProfileModal={this.ShowProfileModal}
                        GetTourDetails={this.GetTourDetails}
                        DeleteModal={this.DeleteModal}
                        // ShowAddOrganizerModal={this.ShowAddOrganizerModal} 
                        AddTour={this.AddTour}
                    />
                    : AppUtils.HandlePageClick(this.props.componentprops, 'home')}
                   <DeleteModal {...this.props} mystate = {this.state} DeleteModal={this.DeleteModal}
                   CloseDeleteModal={this.CloseDeleteModal} DeleteTour = {this.DeleteTour}
                   />
                {((this.state.getTours === true) ? GetToursList(this.props.PnkStore, this.HandleGetToursListSuccessResponse) : "")}
                {((this.state.getTourSitemapList === true) ? GetToursList(this.props.PnkStore, this.HandleGetToursSitemapListSuccessResponse) : "")}
                {((this.state.getEventSitemapList === true) ? SitemapEventsList(this.props.PnkStore, this.HandleGetSitemapEventsListSuccessResponse) : "")}    
                {((this.state.TourDetails === true) ? GetTourDetails(this.props.PnkStore, this.state.tour_id, this.HandleGetTourDetailsSuccessResponse) : "")}
                {((this.state.delete_tour === true) ? DeleteTour(this.props.PnkStore, this.state.deleteTourid, this.HandleDeleteTourDetailsSuccessResponse) : "")}
            </div>
        )
    }
}

export const TourList = PnkConnect(tourList, '');